import type { SVGProps } from 'react'
const SvgSyTechAlarmClock = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M253.8 76.2C203 35.9 130.2 39.8 84 85.3c-45.8 46.1-49.5 119.3-8.4 169.8 35.7-79.3 99-142.9 178.2-178.9"
		/>
		<path d="M419.1 211.1c0-11-9-20-20-20s-20 9-20 20v200L536 488.9c9.9 4.8 21.9.7 26.8-9.2 4.8-9.9.7-21.9-9.2-26.8l-134.7-66.7z" />
		<path d="M622.2 617.3C705.3 533.2 733 409 693.5 297.5c-15.5 2.7-31.3 3.1-46.9 1.1 56 136.2-9.1 292-145.3 348s-292-9.1-348-145.3 9.1-292 145.3-348c64.9-26.7 137.7-26.7 202.7 0-.8-6.6-1.3-13.3-1.3-20 0-9 .9-18 2.4-26.9C339.9 50.5 162.9 137 107 299.5c-38.5 111.9-10.1 236 73.1 320.1l-56.7 56.7c-8.7 8.8-8.5 23 .3 31.7s23 8.5 31.7-.3l59.1-59.1c111.1 84.1 264.8 83.4 375.1-1.8l60.9 60.9c9.3 8 23.4 6.9 31.3-2.4 7.1-8.3 7.1-20.6 0-28.9L622 617.5z" />
		<circle cx={666.7} cy={133.3} r={111.1} />
	</svg>
)
export default SvgSyTechAlarmClock
